import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class CreateMemberNote extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Create Member Note</h1>
				<p>Creates new member notes about the specified user.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> POST </td>
							<td> {`/members/{username}/my_notes`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<p>Do not supply a request parameter with this method.</p>
				<h4>Request body</h4>
				<p>In the request body, supply a <a href="?page=resource-representations-member">note resource</a>.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a <a href="?page=resource-representations-member">note resource</a> as "data" in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>
						POST /members/bluser/notes
						<ul>
							<li>Creates new notes on user "bluser"</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}